import type { User, UserCreate, UserUpdate } from '../types/user';
import { fetcher } from '../utils/fetcher';

const API_URL = '/api/v1/users';

export const getAllUsers = async (): Promise<User[]> => {
    const response = await fetcher(`${API_URL}/read`);
    return response;
};

export const getUserById = async (userId: string): Promise<User> => {
    const response = await fetcher(`${API_URL}/read/${userId}`);
    return response;
};

export const createUser = async (user: UserCreate): Promise<User> => {
    const response = await fetcher(`${API_URL}/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user),
    });
    return response;
};

export const updateUser = async (userId: string, userUpdate: UserUpdate): Promise<User> => {
    const response = await fetcher(`${API_URL}/update/${userId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userUpdate),
    });
    return response;
};

export const deleteUser = async (userId: string, cascade: boolean = false, reassignTo?: string): Promise<boolean> => {
    const params = new URLSearchParams();
    if (cascade) {
        params.append('cascade', 'true');
    }
    if (reassignTo !== undefined) {
        params.append('reassign_to', reassignTo.toString());
    }
    
    const url = `${API_URL}/delete/${userId}${params.toString() ? `?${params.toString()}` : ''}`;
    
    const response = await fetcher(url, {
        method: 'DELETE',
    });
    return response;
};